import { Component, OnInit, Input } from '@angular/core';
import { LottoItem, ItemLoyaltyState, BalanceQuery, config, LOTTO_STATE, LOTTO_TEXT_COLOR, LOYALTY_STATUS } from '@fgb/core';
import { DateTime } from 'luxon';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-lottos-list-item',
  templateUrl: './lottos-list-item.component.html',
  styleUrls: ['./lottos-list-item.component.scss'],
})
export class LottosListItemComponent implements OnInit {
  @Input() lottoItem: LottoItem;
  @Input() ignoreLink: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() featuredIcon: string = 'star';
  statusText: string;
  available: boolean = false;
  config: any = config;
  status = ItemLoyaltyState;
  isNotEnoughPoints: boolean = false;
  showLotto: boolean = true;
  theme: string;
  stockAvailableState: string;
  textColor: string;
  LOTTO_STATE = LOTTO_STATE;
  state = LOYALTY_STATUS;
  showPts: boolean = false;
  constructor(private balanceQuery: BalanceQuery) {}

  ngOnInit() {
    if (!this.isPreview) {
      const requestTime = DateTime.fromISO(this.lottoItem.RequestTime as string, { zone: 'utc' });
      const startDate = DateTime.fromISO(this.lottoItem?.StartDate as string, { zone: 'utc' });

      if (this.lottoItem) {
        if (startDate > requestTime) {
          this.showLotto = false;
        } else {
          this.showLotto = true;
        }
      }

      //If Item state is Available show Pts else show text

      if (this.lottoItem.ItemState === 0) {
        this.showPts = true;
      }

      // tslint:disable-next-line: no-bitwise
      if (this.lottoItem.AllowComingSoon === ItemLoyaltyState.ComingSoon && !this.showLotto) {
        this.statusText = LOTTO_STATE.COMING_SOON;
        this.theme = 'coming-soon';
      } else if (this.lottoItem.ItemState === ItemLoyaltyState.OutOfStock) {
        this.statusText = LOTTO_STATE.SOLD_OUT;
        this.theme = 'sold-out';
      } else if (this.lottoItem.ItemState === ItemLoyaltyState.ItemLimitReached) {
        this.statusText = LOTTO_STATE.LIMIT_REACHED;
        this.theme = 'limit-reached';
      } else {
        this.balanceQuery
          .selectPurse(this.config.purseConfig.virtualLoyalty)
          .pipe(take(1))
          .subscribe((bal) => {
            let currentBal = bal ?? 0;
            if (currentBal < this.lottoItem.PurchasePrice) {
              this.isNotEnoughPoints = true;
              this.statusText = LOTTO_STATE.NOT_ENOUGH_POINT;
              this.theme = 'not-enough-points';
            } else if (this.lottoItem.DisableManualEntry === true && this.lottoItem.ShowOnDisableManualEntry === false) {
              this.statusText = LOTTO_STATE.VIEW;
            } else if (this.lottoItem.ShowOnDisableManualEntry === true && this.lottoItem.NumberOfTicketsPurchased === 0) {
              this.statusText = LOTTO_STATE.LOCKED;
            } else if (this.lottoItem.ShowOnDisableManualEntry && this.lottoItem.NumberOfTicketsPurchased > 0) {
              this.statusText = LOTTO_STATE.ENTERED;
            } else {
              this.statusText = '';
              this.available = true;
            }
          });
      }
      this.getStockAvailableState();
    }
  }

  getStockAvailableState() {
    [this.stockAvailableState, this.textColor] = this.handleStockAvailable(this.lottoItem);
  }

  private handleStockAvailable(lottoItem: LottoItem) {
    if (!lottoItem) return ['', this.theme];
    const startDate = DateTime.fromISO(lottoItem.StartDate as string, { zone: 'utc' });

    const now = DateTime.utc();
    const days = now.diff(startDate, 'days').days;

    // New Stock
    const threeDays = 3;
    if (days <= threeDays) return [LOTTO_STATE.NEW, LOTTO_TEXT_COLOR.NEW];

    // Stock Favourite
    if (lottoItem.Favourite) return [LOTTO_STATE.FEATURED, LOTTO_TEXT_COLOR.GREEN];
    else return ['', this.theme];
  }
}
